import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { api } from '@/api/client';

export function RequireAuth({ children }: { children: ReactNode }) {
  const location = useLocation();
  if (!api.getToken()) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return <>{children}</>;
}

export function GuestOnly({ children }: { children: ReactNode }) {
  if (api.getToken()) {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
}
